import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { renderStyledElementStyles } from '../../../../helpers';

const Wrapper = styled.div`
  display: inline-block;
  transition: font-size 0.4s;
  ${({ theme, dStyles }) => renderStyledElementStyles(theme, dStyles)}
  ${({ theme, vStyles }) => renderStyledElementStyles(theme, vStyles)}

  &.revealed {
    ${({ theme, vStyles }) =>
      renderStyledElementStyles(theme, vStyles.revealed)}
  }
`;

export const StrapLine = ({ className, content, dStyles, vStyles, style }) => {
  return (
    <Wrapper
      className={className}
      dStyles={dStyles.elements?.card.elements?.strapLine}
      vStyles={vStyles.elements?.card.elements?.strapLine}
      style={style}
    >
      {content}
    </Wrapper>
  );
};

StrapLine.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string,
};
